<template>
    <app-data-table :fields="fields" :items="data">
        <template slot="items" slot-scope="data">
            <app-nobr>
                <b-row
                    no-gutters
                    v-for="(item, index) in data.item.items"
                    :key="item.id"
                    align-v="center"
                >
                    <b-col sm cols="12" md="6" lg="6">
                        {{ index + 1 }} - {{ item.serial }} ({{
                            item.item_sub_type.item_type.name
                        }}
                        - {{ item.item_sub_type.name }})
                    </b-col>
                    <b-col sm cols="12" md="4" lg="2">
                        <b-button
                            block
                            variant="danger"
                            size="sm"
                            @click="$emit('unassign-tool', item)"
                            ><i class="fa fa-times" aria-hidden="true"></i>
                        </b-button>
                    </b-col>
                </b-row>
            </app-nobr>
        </template>

        <template slot="actions" slot-scope="data">
            <b-button variant="primary" @click="toAssign(data.item)"
                ><i class="fa fa-plus" aria-hidden="true"></i> Asignar</b-button
            >
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields'
export default {
    data() {
        return {
            fields: fields,
        }
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
        toAssign: {
            type: Function,
            required: true,
        },
    },
}
</script>
